export const mediaIconSize = "mIconZ";
export const mediaImageWidth = "mImgW";
export const mediaImageHeight = "mImgH";
export const mediaContentGap = "mcSp";
